import React from "react";
import "./Experience.css";
import Counter from "../Counter/Counter";
const Experience = () => {
  const stats = [
    { value: 5, label: "years experience" },
    { value: 10, label: "completed projects" },
    { value: 3, label: "companies supported" },
  ];

  return (
    <section className="experience" id='experience' aria-label="Experience highlights">
      {stats.map((stat) => (
        <div className="achievement" key={stat.label}>
          <Counter end={stat.value} />
          <span>{stat.label}</span>
        </div>
      ))}
    </section>
  );
};

export default Experience;
